/**
 * Single multivariate flag for the VOC messaging pack.
 * `control` = current i18n; `otp` = pay-once pack; `trust` = privacy / never-train pack.
 */
export const WEBSITE_VOC_MESSAGING_FLAG = "website-voc-messaging" as const;

export type WebsiteExperimentFlagKey = typeof WEBSITE_VOC_MESSAGING_FLAG;

export const EXPERIMENT_CONTROL_VARIANT = "control";
export const EXPERIMENT_OTP_VARIANT = "otp";
export const EXPERIMENT_TRUST_VARIANT = "trust";

export type ExperimentVariantKey =
  | typeof EXPERIMENT_CONTROL_VARIANT
  | typeof EXPERIMENT_OTP_VARIANT
  | typeof EXPERIMENT_TRUST_VARIANT
  | string;
